import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PaginationDto, ResponsePackage } from '../models/util.model';
import { EditConnectorSwitchDto } from '../models/connector-switch.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root'
})
export class ConnectorSwitchService {
  private pathApi: string;
  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'cim/equipment/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  getAll(dataIn: any) {
    return this.http.post<ResponsePackage<PaginationDto<any>>>(
      `${this.pathApi}getAll`,
      dataIn,
      { headers: this.headers, observe: 'response' }
    );
  }

  createOrUpdate(model: EditConnectorSwitchDto) {
    return this.http.post<ResponsePackage<any>>(
      `${this.pathApi}create`,
      model,
      { headers: this.headers, observe: 'response' }
    );
  }

//   delete(id: number) {
//     return this.http.delete<ResponsePackage<any>>(
//       `${this.pathApi}delete?id=${id}`,
//       { headers: this.headers, observe: 'response' }
//     );
//   }

  getEquipmentStats(type: any) {
    return this.http.post<ResponsePackage<any>>(
      `${this.pathApi}getStats`,
      type,
      { headers: this.headers, observe: 'response' }
    );
  }

  getEquipmentStatsByTemplate(type: any) {
    return this.http.post<ResponsePackage<any>>(
      `${this.pathApi}getStatsByTemplate`,
      type,
      { headers: this.headers, observe: 'response' }
    );
  }

  getById(id: number){
    return this.http.get(`${this.pathApi}getById?id=${id}`, {
        headers: this.headers,
        observe: 'response'
    })
  }

  getEquipmentBySsId(dataIn: any){
    return this.http.post<ResponsePackage<any>>(
      `${this.pathApi}getAllForSelectBySs`,
      dataIn,
      { headers: this.headers, observe: 'response' }
    );
  }
}
